function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeWidth: 0.8
}, /*#__PURE__*/React.createElement("path", {
  fill: "#E4E4E4",
  stroke: "#E4E4E4",
  d: "M7.638 1.327C4.09 2.383 1.478 5.351.934 9.051c-.413 2.807.584 5.55 2.457 7.511.324.34.9-.437.684-.664-1.768-1.853-2.688-4.501-2.15-7.121.656-3.182 3.045-5.902 6.25-6.61 6.858-1.514 12.144 5.821 8.722 12.01a.36.36 0 0 0 .125.487l.203.118a.36.36 0 0 0 .485-.135c1.769-3.196 1.665-7.237-.564-10.125-2.191-2.84-5.99-4.241-9.508-3.195z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3D84FF",
  stroke: "#3D84FF",
  d: "M3.67 16.382c2.688 2.545 6.565 3.322 10.041 1.944 2.638-1.046 4.514-3.28 5.277-5.884.131-.45-.83-.56-.918-.26-.72 2.458-2.554 4.579-5.092 5.422-3.083 1.024-6.633.314-8.849-2.107C-.61 10.315 3.1 2.069 10.17 1.939a.36.36 0 0 0 .36-.352v-.235A.358.358 0 0 0 10.17 1c-3.652.066-7.1 2.176-8.486 5.55-1.364 3.319-.679 7.31 1.986 9.833z"
}));

const SvgInlineLoader = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInlineLoader, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/inline-loader.abdc5866.svg";
export { ForwardRef as ReactComponent };